import type { OrderDTO } from '@wf/shared'

// Status-Reihenfolge der Serviceannahme: Laufendes zuerst, Erledigtes ans Ende — wie der Alt-Monolith.
const STATUS_ORDER = ['arbeit', 'wartet', 'offen', 'fertig', 'abgeholt']
const PRIO_ORDER: Record<string, number> = { hoch: 0, mittel: 1, niedrig: 2 }

function statusRank(status: string): number {
  const index = STATUS_ORDER.indexOf(status)
  return index < 0 ? STATUS_ORDER.length : index
}

function prioRank(prio: string): number {
  return PRIO_ORDER[prio] ?? 1 // unbekannte Priorität wie 'mittel' einordnen
}

// Überfällig: ein geplanter, noch nicht erledigter Auftrag, dessen Termin vor heute liegt (lokaler YMD-String).
function isOverdue(order: OrderDTO, today: string): boolean {
  return order.scheduledDate != null && order.scheduledDate < today && order.status !== 'fertig' && order.status !== 'abgeholt'
}

/**
 * Annahme-Liste: nach Status (laufend zuerst), dann Überfällige nach vorn, dann nach Priorität — exakt die
 * Sortierung des Alt-Monolithen. `today` (lokaler YMD-String) kommt vom Aufrufer herein (testbar, kein
 * verstecktes new Date()). Stabil, mutiert nicht, erhält den Item-Typ.
 */
export function sortIntakeOrders<T extends OrderDTO>(orders: readonly T[], today: string): T[] {
  return [...orders].sort(
    (a, b) =>
      statusRank(a.status) - statusRank(b.status) ||
      Number(isOverdue(b, today)) - Number(isOverdue(a, today)) ||
      prioRank(a.prio) - prioRank(b.prio),
  )
}

/** Kennzahl-Kacheln der Annahme (die laufenden Status; abgeholt wird unten separat gezählt). */
export const INTAKE_STATS = [
  { status: 'offen', label: 'Offen' },
  { status: 'arbeit', label: 'In Arbeit' },
  { status: 'wartet', label: 'Wartet' },
  { status: 'fertig', label: 'Fertig' },
] as const

export function countByStatus(orders: readonly OrderDTO[], status: string): number {
  return orders.filter((order) => order.status === status).length
}
